{ Link } = require 'react-router-dom'
classnames = require 'classnames'

styles = require './customer-card.styl'
stylesAsing = require 'components/shared/AssignerPreviewComponent/assigner-preview.styl'
BaseComponent = require 'components/BaseComponent'
InlineTextInput = require 'components/shared/InlineTextInput/InlineTextInput'
InlineTimezoneInput = require 'components/shared/InlineTimezoneInput/InlineTimezoneInput'
CustomersActionCreator = require 'actions/CustomersActionCreator'
CRMInfoModuleActionCreator = require('actions/CRMInfoModuleActionCreator').default
CRMInfoModuleStore = require 'stores/CRMInfoModuleStore'
CustomerCardCredentialsFormByCustomerComponent = require './CustomerCardCredentialsFormComponent/CustomerCardCredentialsFormByCustomerComponent'
crminfo = require '@verdaccio/crminfo'
emptyAvatarImage = require("components/shared/images/unknown.png")
BlacklistedWarningModal = require 'components/shared/BlacklistedWarningModal'
SwitchComponent = require 'components/shared/SwitchComponent'
AuthStore = require 'stores/AuthStore'
XMPPStore = require 'stores/XMPPStore'
InterfaceActionCreator = require 'actions/InterfaceActionCreator'
{ BLACKLIST_EDIT_ACCESS } = require 'constants/Agents'

CustomerNicknameComponent = require 'components/customers/CustomerNicknameComponent/CustomerNicknameComponent'

propTypes = require 'prop-types'

EXTENDED_SUBSCRIPTION_LIST = [
  'subscription_nerdify_basic'
  'subscription_nerdify_premium'
  'subscription_nerdify_basic_trial'
  'subscription_nerdify_premium_trial'
  'subscription_geeklyhub_premium'
  'subscription_geeklyhub_premium_plus'
  'subscription_premium_addons'
]

getAvatarSrc = (customer) -> emptyAvatarImage

class CustomerCardComponent extends BaseComponent
  constructor: (props) ->
    super(props)
    @initComponent()

  @propTypes:
    customer: propTypes.object.isRequired
    onReadyChange: propTypes.func

  dependsOnStores: [CRMInfoModuleStore, XMPPStore]

  getState: ->
    customerFeedbacks: CRMInfoModuleStore.payments?.profile_client_feedbacks
    clientId: CRMInfoModuleStore.payments?.clientId
    crmCustomerData: CRMInfoModuleStore.payments
    sameCustomersLoading: false

  # todo move to props
  updateCustomerAttribute: (attribute, value) =>
    setTimeout(
      =>
        CustomersActionCreator.update(@props.customer.id, {"#{attribute}": value})
      10
    )

  toggleBlacklist: (value) ->
    data = optin: value
    data.optout = true if value
    setTimeout(
      =>
        CustomersActionCreator.update(@props.customer.id, data)
      10
    )

  onOptoutToggle: (value) =>
    setTimeout(
      =>
        CustomersActionCreator.update(@props.customer.id, { optout: value })
      10
    )

  onAppblockToggle: (value) =>
    setTimeout(
      =>
        CustomersActionCreator.update(@props.customer.id, { appblock: value })
      10
    )

  onBlacklistToggle: (value) =>
    @setState sameCustomersLoading: true
    CRMInfoModuleActionCreator.getSameCustomers(
      @state.clientId
      (sameCustomers) =>
        if sameCustomers.length > 0
          @setState sameCustomersLoading: false
          InterfaceActionCreator.openModal BlacklistedWarningModal, {
            onProceed: => @toggleBlacklist value
            sameCustomers: sameCustomers
          }
        else
          @setState sameCustomersLoading: false
          @toggleBlacklist value
      (error) =>
        @setState sameCustomersLoading: false
        console.error(error)
    )

  render: ->
    { customer, customerIsOnline } = @props
    { avg_mark, count } = @state.customerFeedbacks || {}
    { Tooltip, StarRating } = crminfo.controls
    { crm_ids = [] } = customer
    tags = @state?.crmCustomerData?.tags
    xmppRosters = XMPPStore.xmppRosters
    xmppRoster = xmppRosters.find((roster) -> (roster.name || '').includes(crm_ids[0]));
    haveExtendedSubscription = (tags || []).some((tag) -> EXTENDED_SUBSCRIPTION_LIST.indexOf(tag) > -1)

    React.createElement("div", {"className": ( styles.container )},
      React.createElement("div", {"className": styles.primary_info},
        React.createElement(Link, {"to": "/customers/#{customer.id}", "className": (styles.link)},
          React.createElement("img", {"className": (styles.image), "src": (getAvatarSrc(customer))}),
          (if !!xmppRoster
            React.createElement("div", {"className": (stylesAsing["indicator_#{if xmppRoster.isOnline then 'online' else 'offline'}"])})
          )
        ),

        React.createElement("div", {"className": styles.info},
          React.createElement(InlineTextInput, { \
            "isTitle": true,  \
            "value": customer.name,  \
            "onSubmit": ( R.partial(@updateCustomerAttribute, ['name']) ),  \
            "placeholder": ( 'Client\'s name' ),  \
            "className": (styles.name)
          }),
          React.createElement(InlineTimezoneInput, { \
            "className": styles.time,  \
            "value": customer.timezone,  \
            "auto_timezone": customer.auto_timezone,  \
            "onSubmit": ( R.partial(@updateCustomerAttribute, ['timezone']) )
          })
        )
      ),
      (if @props.customerLink
        React.createElement("div", {"className": styles.optout},
          React.createElement(Link, { \
            "to": "/conversations/all_conversations/#{@props.customerLink}"}, """
            Conversation
""")
        )
      ),
      React.createElement("div", {"className": (styles.credentials)},
        React.createElement(CustomerCardCredentialsFormByCustomerComponent, { \
          "customer": customer,  \
          "onReadyChange": @props.onReadyChange
        })
      ),
      React.createElement("div", {"className": (styles.rating)},
        React.createElement("span", {"className": (styles.rating_label)}, "Average order rating"),
        React.createElement(Tooltip, {"content": ("Average rating based on #{count || 0} ratings"), "positionRight": true},
          React.createElement(StarRating, {"rate": (avg_mark || 0), "width": (90)})
        )
      ),
      (if haveExtendedSubscription
        React.createElement("div", {"className": (styles.nickname)},
          React.createElement("i", {"className": (styles.nickname_icon)}),
          React.createElement("span", {"className": (styles.nickname_label)}, "Nickname"),
          React.createElement(CustomerNicknameComponent, {"customer": customer})
        )
      ),
      React.createElement("div", {"className": 'clr'}),
      React.createElement("div", {"className": (styles.optout)},
        React.createElement(SwitchComponent, { \
          "value": (!!customer.optout),  \
          "onToggle": (@onOptoutToggle),  \
          "auto": (!!customer.options.auto_optout),  \
          "disabled": (!@state.clientId || customer.options.auto_optout)
        }),
        React.createElement("span", {"className": (styles.optout__text)}, "Optout")
      ),
      React.createElement("div", {"className": (styles.optout)},
        React.createElement(SwitchComponent, { \
          "value": (!!customer.optin),  \
          "onToggle": (@onBlacklistToggle),  \
          "className": (classnames({ "#{styles.loading_cursor}": @state.sameCustomersLoading })),  \
          "disabled": (!BLACKLIST_EDIT_ACCESS[AuthStore.user.role] || @state.sameCustomersLoading || !@state.clientId)
        }),
        React.createElement("span", {"className": (styles.optout__text)}, "Blacklist")
      ),
      React.createElement("div", {"className": (styles.optout)},
        React.createElement(SwitchComponent, { \
          "value": (!!customer.appblock),  \
          "onToggle": (@onAppblockToggle),  \
          "disabled": (!@state.clientId)
        }),
        React.createElement("span", {"className": (styles.optout__text)}, "Appblock")
      )
    )

module.exports = CustomerCardComponent
